import Circle from "../../../../../src/entities/Circle";
import { ARC_COLOR_ARR } from "../types/Config";


export default function setCircleColors(circle: Circle, radians: number[], isBtws: boolean[], isShownSecondAngles:boolean) {
  let r = radians;
  let ArcColors = [...ARC_COLOR_ARR];
  !isShownSecondAngles ? ArcColors[0] = 0x000000 : "";

  if (isBtws[0] && isBtws[1]) {
    circle.setColors(ArcColors)
  } else if (!isBtws[0] && !isBtws[1]) {
    circle.setColors(ArcColors);
    r = [radians[1], radians[0], radians[3], radians[2]];
  } else {
    circle.setColors(Array(4).fill(0x000000))
  }
  return r;
}